import type { InviteFailure } from './inviteOutcome';

/**
 * Отказ вступления, переданный с одного экрана на другой.
 *
 * <p>Приглашение приходит всплывашкой, и «Принять» в ней - полноценное вступление: сервер может
 * отказать. Разбирать отказ всплывашке нечем, окно состава умеет всё: пересечение по времени
 * показывает блоком с переходом, нехватку Discord - кнопкой привязки. Поэтому всплывашка ведёт
 * на заявку и отдаёт окну готовый ответ сервера, а не заставляет его спрашивать второй раз:
 * повторный запрос сервер отклонил бы снова и второй раз записал бы отказ в журнал переходов -
 * тот самый, по которому меряют, помогает ли кнопка перехода.
 *
 * <p>Почему не параметр адреса: отказ - это факт одной попытки, а не свойство страницы. В адресе
 * он пережил бы перезагрузку и уехал бы в чужие руки вместе со ссылкой, и человек получил бы
 * блок «у вас уже есть сессия» на пустом месте.
 *
 * <p>Читается ровно один раз: окно, которое его забрало, за него и отвечает.
 */
let pending: { sessionId: string; failure: InviteFailure } | null = null;

export const rememberJoinFailure = (sessionId: string, failure: InviteFailure) => {
  pending = { sessionId, failure };
};

/**
 * Куда вести человека после «Принять» во всплывашке и что передать странице.
 *
 * <p>Отказ - запомнить и попросить страницу раскрыть окно состава этого сбора (`?session=`):
 * там и блок перехода при пересечении по времени, и кнопка привязки Discord. Удача - ничего
 * передавать не надо, человек и так приедет на заявку и увидит состав.
 *
 * <p>Живёт в модели, а не в самой всплывашке: решение проверяемое, а всплывашка в тестовой
 * среде не доживает до кадра, где рисуется её содержимое.
 */
export const handOffJoinFailure = (sessionId: string, failure: InviteFailure | null) => {
  if (!failure) {
    return undefined;
  }

  rememberJoinFailure(sessionId, failure);

  return { session: sessionId };
};

/** Забрать отказ для этого сбора; для любого другого - ничего, и чужой отказ не пропадает. */
export const takeJoinFailure = (sessionId: string | undefined | null): InviteFailure | null => {
  if (!sessionId || pending?.sessionId !== sessionId) {
    return null;
  }

  const { failure } = pending;
  pending = null;

  return failure;
};
